<template>
    <ClientSummary
        v-if="!isError.hasError"
        :client="infoClient"
        :loading="isLoadingClient"
        :ui="ui"
        :balance="infoClient.total"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError">
        <header>
            <v-card-title>Última Gestión</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <div class="content_information" role="region" aria-label="Última Gestión" :aria-busy="isLoadingManagement">
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-account"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">Nombre del Gestor</div>
                    <div class="data_info" :title="managementInformation.gestor">{{ managementInformation.gestor || 'N/A' }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-code-array"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">{{ catalogSettings.action_label }}</div>
                    <div class="data_info" :title="managementInformation.codigo_accion">{{ managementInformation.codigo_accion || 'N/A' }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-code-braces-box"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">{{ catalogSettings.result_label }}</div>
                    <div class="data_info" :title="managementInformation.codigo_resultado">{{ managementInformation.codigo_resultado || 'N/A' }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-calendar-range"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">Fecha de Creación </div>
                    <div class="data_info" :title="managementInformation.updated_at">{{ managementInformation.updated_at || 'N/A' }}</div>
                </div>
            </div>
            <div class="item_info_100">
                <div class="item_icon">
                    <v-icon icon="mdi-format-align-justify"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">Comentarios</div>
                    <div class="data_info_comments">{{ managementInformation.comentario || 'N/A' }}</div>
                </div>
            </div>
        </div>

        <div style="width: 100%;" role="region" aria-label="Teléfonos" :aria-busy="isLoadingGetPhone">
            <header>
                <v-card-title>Teléfonos</v-card-title>
                <v-divider class="mx-3"></v-divider>
            </header>

            <div class="content_accion">
                <div>
                    <v-text-field
                        v-model="searchGetPhone"
                        label="Búsqueda"
                        prepend-inner-icon="mdi-magnify"
                        single-line
                        variant="outlined"
                        hide-details
                        class="filter"
                        :disabled="isLoadingGetPhone"
                    ></v-text-field>
                </div>
                <div>
                    <v-btn
                        icon="mdi-reload"
                        size="small"
                        variant="outlined"
                        color="indigo-darken-3"
                        class="mr-2"
                        :disabled="isLoadingGetPhone"
                        data-cy="general-phone-refresh"
                        @click="getTelephonesByClient()"
                    ></v-btn>
                </div>
            </div>

            <v-data-table
                data-cy="general-phone-table"
                :headers="dataSourceGetPhone.headers"
                :items="dataSourceGetPhone.data"
                :search="searchGetPhone"
                :loading="isLoadingGetPhone"
                fixed-header
                no-data-text="Sin datos para mostrar"
                loading-text="Cargando información... Espere un momento"
            >
                <template v-slot:loading>
                    <v-skeleton-loader type="table-row@3" aria-label="Cargando teléfonos" />
                </template>
                <template v-slot:item="{ item }">
                    <tr :style="{ backgroundColor: item.mismo_numero > 1 ? 'rgb(193 236 169)' : '' }">
                        <td>{{ item.numero_tel }}</td>
                        <td>{{ item.agregado_por }}</td>
                        <td>{{ item.mismo_numero }}</td>
                        <td>{{ item.prioridad }}</td>
                        <td>
                            <v-btn
                                class="elevation-0 mr-1 text-none"
                                density="comfortable"
                                icon="mdi-information"
                                color="indigo-darken-3"
                                data-cy="phone-relationships"
                                @click="getInfoPhone(item)"
                            ></v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>

        <div style="width: 100%;" role="region" aria-label="Información del Deudor" :aria-busy="isLoadingConfig || isLoadingDetails">
            <header>
                <v-card-title>Información del Deudor</v-card-title>
                <v-divider class="mx-3"></v-divider>
            </header>

            <v-tabs v-model="tab" color="indigo-darken-3">
                <v-tab v-for="debtorTab in debtorTabs" :key="debtorTab.key" :value="debtorTab.key">{{ debtorTab.title }}</v-tab>
            </v-tabs>
            <v-window v-model="tab">
                <v-window-item v-for="debtorTab in debtorTabs" :key="debtorTab.key" :value="debtorTab.key">
                    <div class="content_information">
                        <div v-for="field in debtorTab.fields" :key="field.key" class="item_info_33">
                            <div class="item_icon">
                                <v-icon :icon="debtorTab.icon"></v-icon>
                            </div>
                            <div class="item_data">
                                <div class="data_title">{{ field.name }}</div>
                                <div class="data_info" :title="getFieldValue(field.key)">{{ getFieldValue(field.key) }}</div>
                            </div>
                        </div>
                    </div>
                </v-window-item>
            </v-window>
        </div>
    </div>
    <div v-if="isError.hasError" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>
    <SnackbarComponent :value="snackbarData"/>

    <template>
      <v-dialog v-model="dialogSamePhone.open" width="700px">
        <v-card>
          <v-card-title>
            <div>
              <span class="text-h5">Clientes con Mismo Teléfono</span>
            </div>
          </v-card-title>
          <v-card-text>
            <v-data-table
              data-cy="phone-relationship-table"
              :headers="dataSourceSamePhone.headers"
              :items="dataSourceSamePhone.data"
              :loading="dialogSamePhone.loading"
              no-data-text="Sin datos para mostrar"
              loading-text="Cargando información... Espere un momento"
            >
              <template v-slot:[`item.id_cliente`]="{ item }">
                <td class="redirect_user" @click="redirectClient(item)">
                  {{  item.id_cliente  }}
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
</template>

<script>
import { DespachoCatalogService } from '@/services/DespachoCatalogService';
import ClientSummary from '@/components/managements/ClientSummary.vue'
import SnackbarComponent from '@/components/Snackbar'
import { EncryptService } from '@/services/EncryptService'
import { ManagementsService } from '@/services/ManagementsService'
import { ResourcesService } from '@/services/ResourcesService'
import { useUiStore } from '@/stores/ui'
import { useDebtorFieldsStore } from '@/stores/debtorFields'

const FIELD_MAPPINGS = {
    CLIENTE_UNICO: { group: 'generalInformation', key: 'id_cliente' },
    NOMBRE_CTE: { group: 'generalInformation', key: 'nombre' },
    EDAD_CLIENTE: { group: 'generalInformation', key: 'edad' },
    TERRITORIO: { group: 'generalInformation', key: 'territorio' },
    ZONA: { group: 'generalInformation', key: 'zona' },
    GERENCIA: { group: 'generalInformation', key: 'gerencia' },
    PRODUCTO: { group: 'generalInformation', key: 'producto' },
    CARTERA: { group: 'generalInformation', key: 'cartera' },
    RMD: { group: 'generalInformation', key: 'rmd' },
    ESTRATEGIA: { group: 'generalInformation', key: 'correo_electronico' },
    ESTATUS_PLAN: { group: 'generalInformation', key: 'estatus_plan' },
    FECHA_ASIGNACION: { group: 'paymentInformation', key: 'fecha_asignacion' },
    DIAS_ASIGNACION: { group: 'paymentInformation', key: 'dias_asignacion' },
    ATRASO_MAXIMO: { group: 'paymentInformation', key: 'atraso_max' },
    SALDO: { group: 'paymentInformation', key: 'saldo' },
    MORATORIOS: { group: 'paymentInformation', key: 'moratorios' },
    SALDO_TOTAL: { group: 'paymentInformation', key: 'total' },
    FECHA_ULTIMO_PAGO: { group: 'paymentInformation', key: 'fecha_pago_ultimo' },
    IMP_ULTIMO_PAGO: { group: 'paymentInformation', key: 'importe_pago_ultimo' },
    FIDIAPAGO: { group: 'paymentInformation', key: 'dia_de_pago' },
    CAMPANIA: { group: 'paymentInformation', key: 'campania' },
    'ID GRUPO': { group: 'paymentInformation', key: 'id_grupo' },
    GRUPO_MAZ: { group: 'paymentInformation', key: 'nombre_grupo' },
    DIRECCION_CTE: { group: 'directionInformation', key: 'direccion' },
    NUM_EXT_CTE: { group: 'directionInformation', key: 'num_ext' },
    NUM_INT_CTE: { group: 'directionInformation', key: 'num_int' },
    CP_CTE: { group: 'directionInformation', key: 'cp' },
    COLONIA_CTE: { group: 'directionInformation', key: 'colonia' },
    POBLACION_CTE: { group: 'directionInformation', key: 'poblacion' },
    ESTADO_CTE: { group: 'directionInformation', key: 'estado' },
    REFERENCIAS_DOMICILIO: { group: 'directionInformation', key: 'referencia_domicilio' },
    CALLE_EMPLEO: { group: 'trabajoInformation', key: 'direccion' },
    NUM_EXT_EMPLEO: { group: 'trabajoInformation', key: 'num_ext' },
    NUM_INT_EMPLEO: { group: 'trabajoInformation', key: 'num_int' },
    COLONIA_EMPLEO: { group: 'trabajoInformation', key: 'colonia' },
    POBLACION_EMPLEO: { group: 'trabajoInformation', key: 'poblacion' },
    ESTADO_EMPLEO: { group: 'trabajoInformation', key: 'estado' },
    NOMBRE_AVAL: { group: 'avalInformation', key: 'nombre_aval' },
    TEL_AVAL: { group: 'avalInformation', key: 'numero_tel' },
    CALLE_AVAL: { group: 'avalInformation', key: 'direccion' },
    NUM_EXT_AVAL: { group: 'avalInformation', key: 'num_ext' },
    COLONIA_AVAL: { group: 'avalInformation', key: 'colonia' },
    CP_AVAL: { group: 'avalInformation', key: 'cp' },
    POBLACION_AVAL: { group: 'avalInformation', key: 'poblacion' },
    ESTADO_AVAL: { group: 'avalInformation', key: 'estado' },
}

const DETAIL_FIELDS = {
    generalInformation: ['id_cliente', 'nombre', 'edad', 'cartera', 'producto', 'correo_electronico', 'estatus_plan', 'rfc', 'territorio', 'zona', 'gerencia'],
    paymentInformation: ['total', 'dia_de_pago', 'atraso_max', 'moratorios', 'fecha_pago_ultimo', 'id_grupo', 'saldo', 'importe_pago_ultimo', 'nombre_grupo', 'campania', 'fecha_asignacion', 'dias_asignacion'],
    directionInformation: ['direccion', 'num_ext', 'num_int', 'colonia', 'poblacion', 'estado', 'cp', 'cuadrante', 'referencia_domicilio'],
    trabajoInformation: ['direccion', 'num_ext', 'num_int', 'colonia', 'poblacion', 'estado'],
    avalInformation: ['nombre_aval', 'direccion', 'num_ext', 'num_int', 'colonia', 'poblacion', 'estado', 'cp', 'numero_tel'],
}

const MONEY_FIELDS = new Set(['total', 'moratorios', 'saldo', 'importe_pago_ultimo'])

const DEBTOR_TABS = [
    { key: 'general', title: 'General', icon: 'mdi-account' },
    { key: 'credito', title: 'Crédito', icon: 'mdi-cash' },
    { key: 'domicilios', title: 'Domicilios', icon: 'mdi-home-map-marker' },
    { key: 'trabajos', title: 'Trabajos', icon: 'mdi-briefcase' },
    { key: 'avales', title: 'Aval(es)', icon: 'mdi-account-check' },
]

export default {
    name: "GeneralInformation",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },
    data() {
        return {
            catalogSettings: { action_label: 'Código Acción', result_label: 'Código Resultado' },
            idClient: null,

            infoClient: {
                id_cliente: 'N/A',
                nombre: 'N/A',
                saldo: 'N/A',
                total: 'N/A',
                estado: 'N/A',
            },

            searchGetPhone: '',
            isLoadingClient: true,
            isLoadingManagement: true,
            isLoadingDetails: true,
            isLoadingConfig: true,
            isLoadingGetPhone: true,

            managementInformation: {
                gestor: 'N/A',
                codigo_accion: 'N/A',
                codigo_resultado: 'N/A',
                updated_at: 'N/A',
                comentario: 'N/A',
            },

            dataManagementInformation: {
                generalInformation: {
                    id_cliente: null,
                    nombre: null,
                    edad: null,
                    cartera: null,
                    producto: null,
                    correo_electronico: null,
                    estatus_plan: null,
                    rmd: null,
                    rfc: null,
                    territorio: null,
                    zona: null,
                    gerencia: null,
                },
                paymentInformation: {
                    total: null,
                    dia_de_pago: null,
                    atraso_max: null,
                    moratorios: null,
                    fecha_pago_ultimo: null,
                    id_grupo: null,
                    saldo: null,
                    importe_pago_ultimo: null,
                    nombre_grupo: null,
                    campania: null,
                    fecha_asignacion: null,
                    dias_asignacion: null,
                },
                directionInformation: {
                    direccion: null,
                    num_ext: null,
                    num_int: null,
                    colonia: null,
                    poblacion: null,
                    estado: null,
                    cp: null,
                    cuadrante: null,
                    referencia_domicilio: null,
                },
                trabajoInformation: {
                    direccion: null,
                    num_ext: null,
                    num_int: null,
                    colonia: null,
                    poblacion: null,
                    estado: null,
                },
                avalInformation: {
                    nombre_aval: null,
                    direccion: null,
                    num_ext: null,
                    num_int: null,
                    colonia: null,
                    poblacion: null,
                    estado: null,
                    cp: null,
                    numero_tel: null,
                },
            },

            debtorConfig: {},

            dataSourceGetPhone: {
                data: [],
                headers: [
                    { align: "start", key: "numero_tel", title: "Número de Teléfono" },
                    { key: "agregado_por", title: "Usuario Registro" },
                    { key: "mismo_numero", title: "Clientes con el Mismo Número" },
                    { key: "prioridad", title: "Número de Exitos" },
                    { key: "actions", title: "Acciones" },
                ]
            },
            tab: 'general',
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            isError: {
                hasError: false,
                msg: '',
            },

            dialogSamePhone: {
                open: false,
                loading: false,
            },
            dataSourceSamePhone: {
                data: [],
                headers: [
                    {
                        align: "start",
                        key: "id_cliente",
                        title: "Contrato",
                    },
                    {
                        key: "nombre",
                        title: "Nombre del Cliente",
                    },
                ]
            },
            typeClassConvenio: 'gray'
        }
    },
    computed:{
        ui() {
            const store = useUiStore()
            return store.ui;
        },
        debtorTabs() {
            return DEBTOR_TABS
                .map((debtorTab) => ({
                    ...debtorTab,
                    fields: this.debtorConfig[debtorTab.key] || [],
                }))
                .filter((debtorTab) => debtorTab.fields.length > 0)
        },
    },
    async mounted() {
        try { this.catalogSettings = (await DespachoCatalogService.management()).settings; } catch (e) { /* Existing information remains available with default labels. */ }
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created () {
        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        try {
            const params = await EncryptService.decrypt(DATA_PARAMS)
            const client = params ? JSON.parse(params) : null
            if (!client || client.id === null || client.id === undefined || client.id === '') {
                throw new Error('Invalid client route')
            }
            this.idClient = client.id
        } catch {
            this.isError.hasError = true
            this.isError.msg = 'Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.'
            return
        }

        // Each loader owns its loading flag; no section waits for another response.
        await Promise.all([
            this.getTelephonesByClient(),
            this.loadDebtorFieldsConfig(),
            this.getClientInformation(),
            this.getManagementInformation(),
            this.getAllManagementInformation(),
        ])
    },
    methods: {
        loadDebtorFieldsConfig: async function () {
            this.isLoadingConfig = true
            try {
                const store = useDebtorFieldsStore()
                if (!store.loaded) {
                    const response = await store.cargar()
                    if (response.error) {
                        this.snackbarData.description = response.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
                this.debtorConfig = store.tabs || {}
            } catch {
                this.snackbarData.description = 'No se pudo cargar la información. Intente de nuevo.'
                this.snackbarData.openSnackbar = true
            } finally {
                this.isLoadingConfig = false
            }
        },
        loadClientSection: async function (loadingFlag, request, applyResponse) {
            this[loadingFlag] = true
            try {
                const encryptedClient = await EncryptService.encrypt(this.idClient)
                const response = await request(encryptedClient)
                if (response.error) {
                    this.snackbarData.description = response.msg
                    this.snackbarData.openSnackbar = true
                } else {
                    applyResponse(response)
                }
            } catch {
                this.snackbarData.description = 'No se pudo cargar la información. Intente de nuevo.'
                this.snackbarData.openSnackbar = true
            } finally {
                this[loadingFlag] = false
            }
        },

        getClientInformation: function () {
            return this.loadClientSection('isLoadingClient', ManagementsService.getClientInformation, ({ response }) => {
                this.infoClient = response
                this.infoClient.total = ResourcesService.moneyFormat(this.infoClient.total)
                switch (this.infoClient.estado) {
                    case 'Convenio Activo':
                    case 'Convenio Completado':
                    case 'Pago Intención Activo':
                    case 'Pago Intención Completado':
                        this.typeClassConvenio = 'green'
                        break
                    case 'Convenio Cancelado':
                    case 'Pago Intención Cancelado':
                        this.typeClassConvenio = 'red'
                        break
                    default:
                        this.typeClassConvenio = 'gray'
                }
            })
        },

        getManagementInformation: function () {
            return this.loadClientSection('isLoadingManagement', ManagementsService.getManagementInformation, ({ msg, response }) => {
                if (msg !== 'No existe una gestión activa para este usuario') {
                    this.managementInformation = response
                }
            })
        },

        getTelephonesByClient: function () {
            return this.loadClientSection('isLoadingGetPhone', ManagementsService.getTelephonesByClient, ({ response }) => {
                this.dataSourceGetPhone.data = response.map(phone => ({
                    ...phone,
                    mismo_numero: phone.relacion.length,
                    reaction: -1,
                }))
            })
        },

        getAllManagementInformation: function () {
            return this.loadClientSection('isLoadingDetails', ManagementsService.getAllManagementInformation, ({ response }) => {
                for (const [group, keys] of Object.entries(DETAIL_FIELDS)) {
                    const details = response[group]
                    if (!details) continue
                    for (const key of keys) {
                        const value = details[key]
                        details[key] = value === null ? 'N/A'
                            : group === 'paymentInformation' && MONEY_FIELDS.has(key)
                                ? ResourcesService.moneyFormat(value) : value
                    }
                }
                this.dataManagementInformation = response
            })
        },

        getFieldValue: function (fieldKey) {
            const mapping = FIELD_MAPPINGS[fieldKey]
            if (!mapping) {
                return 'N/A'
            }
            const group = this.dataManagementInformation[mapping.group]
            if (!group) {
                return 'N/A'
            }
            const value = group[mapping.key]
            return value === null || value === undefined || value === '' ? 'N/A' : value
        },

        getInfoPhone: function (item) {
            this.dialogSamePhone.loading = true
            this.dataSourceSamePhone.data = item.relacion
            this.dialogSamePhone.open = true
            this.dialogSamePhone.loading = false
        },

        redirectClient: async function (item) {
            const STR_FORM = JSON.stringify({ id: item.id_cliente })
            const ENC_FORM = await EncryptService.encrypt(STR_FORM)
            const NEW_WINDOW = window.open(this.$router.resolve({ path: `/SGCCV/access-search-management/${ENC_FORM}/general` }).href, '_blank');
            if (NEW_WINDOW) {
                NEW_WINDOW.focus();
            }
        },
    },
}
</script>

<style scoped>
    .title_container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
        font-size: 12px;
    }
    .title_section {
        width: 25%;
        display: flex;
        justify-content: center;
        font-size: 12pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }
    .container_submenu {
        height: calc(100% - 50px);
        overflow: auto;
        margin-bottom: 30px;
    }
    .content_information {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
    .item_info_25 {
        display: flex;
        flex-direction: row;
        padding: 20px;
        width: 25%;
    }
    .item_info_100 {
        display: flex;
        flex-direction: row;
        padding: 20px;
        width: 100%;
    }
    .item_info_33 {
        display: flex;
        flex-direction: row;
        padding: 20px;
        width: calc(100% / 3);
    }
    .item_info_50 {
        display: flex;
        flex-direction: row;
        padding: 20px;
        width: 50%;
    }
    .item_icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
    }
    .item_data {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;
        width: calc(100% - 60px)
    }
    .data_title {
        font-size: 9pt;
        font-weight: 600;
    }
    .data_info {
        font-size: 16pt;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .data_info_comments {
        font-size: 16pt;
    }

    .redirect_user {
        text-decoration: underline;
        color: blue;
        cursor: pointer;
    }
    .redirect_user:hover {
        text-decoration: underline;
        color: rgb(82, 9, 179);
        cursor: pointer;
    }

    @media all and (max-width: 1200px) {
        .item_info_25 {
            display: flex;
            flex-direction: row;
            padding: 20px;
            width: calc(100% / 3);
        }
        .item_info_33 {
            display: flex;
            flex-direction: row;
            padding: 20px;
            width: calc(100% / 3);
        }
    }
    @media all and (max-width: 900px) {
        .item_info_25 {
            display: flex;
            flex-direction: row;
            padding: 20px;
            width: calc(100% / 2);
        }
        .item_info_33 {
            display: flex;
            flex-direction: row;
            padding: 20px;
            width: calc(100% / 2);
        }
    }
    @media all and (max-width: 600px) {
        .item_info_25 {
            display: flex;
            flex-direction: row;
            padding: 20px;
            width: 100%;
        }
        .item_info_33 {
            display: flex;
            flex-direction: row;
            padding: 20px;
            width: 100%;
        }
    }

</style>
